// Load initial elements once all are loaded

const keyElement = document.querySelector('.design-symbol-lg');
const elementlist = document.querySelectorAll('.design-symbol-lg, .design-symbol-sm, .design-symbol-lg, .logo, .next-button, .intro-title, .intro-paragraph, .intro-button')

function loaded() {
  elementlist.forEach(e => {
    e.classList.add("reveal");
  });
}

if (keyElement.complete) {
  loaded()
  console.log('loaded');
} else {
  keyElement.addEventListener('load', loaded)
  keyElement.addEventListener('error', function() {
      console.log('error');
  })
}

// Reveal elements on scroll

const appearOptions = {
  threshold: 0.6
};

const appearOnScroll = new IntersectionObserver(function(
  entries,
  appearOnScroll
) {
  entries.forEach(entry => {
    if (!entry.isIntersecting) {
      return;
    } else {
      entry.target.classList.add("reveal");
      appearOnScroll.unobserve(entry.target);
    }
  });
},
appearOptions);

const fadeList = document.querySelectorAll(".principle-image, .end-symbol");
fadeList.forEach(fader => {
  appearOnScroll.observe(fader);
});

// Smoothscroll to values
const scrollButton = document.getElementById("next-button");
const scrollTarget = document.getElementById("what-we-value");


scrollButton.onclick = function() {
    scrollTarget.scrollIntoView({behavior: "smooth", block: "center"});
}
